export default "__VITE_ASSET__5YHiWRiI__"